import { render, staticRenderFns } from "./CardPendency.vue?vue&type=template&id=38ac4bf7&scoped=true&"
import script from "./CardPendency.vue?vue&type=script&lang=js&"
export * from "./CardPendency.vue?vue&type=script&lang=js&"
import style0 from "./CardPendency.vue?vue&type=style&index=0&id=38ac4bf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac4bf7",
  null
  
)

export default component.exports